module.exports = {"id":"231478","name":"Lautaro Martínez","rating":"74","photo":"./data/images/photos/3/231478.png","club":{"name":"Racing Club","logo":"./data/images/clubs/RacingClub.png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LautaroMartinez0.json
// module id = 2445
// module chunks = 0